import Reveal from "./Reveal";

const items = [
  {
    n: "01",
    title: "Costi chiari",
    text: "Nessuna voce nascosta. Ti spieghiamo ogni costo in modo semplice, così sai sempre cosa paghi e perché.",
  },
  {
    n: "02",
    title: "Assistenza continua",
    text: "Un riferimento sempre disponibile: dalla scelta dell'offerta alla gestione della fornitura nel tempo.",
  },
  {
    n: "03",
    title: "Professionalità",
    text: "Analizziamo il mercato al posto tuo e ti proponiamo solo soluzioni realmente convenienti e affidabili.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="perche"
      data-testid="why-section"
      className="relative py-24 lg:py-32 bg-forest-900 text-sage-50 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-sage-300">
            Perché sceglierci
          </span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight leading-tight text-sage-50">
            Tre promesse che manteniamo,
            <br className="hidden md:block" /> in ogni bolletta.
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-sage-50/10 rounded-2xl overflow-hidden">
          {items.map((item, i) => (
            <Reveal
              key={item.n}
              delay={i * 0.1}
              className="bg-forest-900 p-8 lg:p-10"
            >
              <span className="font-serif text-6xl lg:text-7xl text-sage-300/70 leading-none">
                {item.n}
              </span>
              <h3 className="mt-6 font-sans text-2xl font-medium text-sage-50">
                {item.title}
              </h3>
              <p className="mt-4 text-base font-light text-sage-200/80 leading-relaxed">
                {item.text}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
